import { z } from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { Leads } from '@/features/leads'

const leadsSearchSchema = z
  .object({
    branch: z.string().optional(),
    department: z.string().optional(),
    startDate: z.string().optional(),
    endDate: z.string().optional(),
    language: z.string().optional(),
  })
  .catch({})

export const Route = createFileRoute(
  '/_authenticated/new-vehicle/lead-performance/'
)({
  validateSearch: leadsSearchSchema,
  beforeLoad: ({ search }) => {
    if (!search?.language) {
      throw redirect({
        to: '/new-vehicle/lead-performance',
        search: {
          branch: search?.branch,
          department: search?.department,
          startDate: search?.startDate,
          endDate: search?.endDate,
          language: 'en',
        },
      })
    }
  },
  component: Leads,
})
